import { Component, Input, OnChanges, input } from '@angular/core';

@Component({
  selector: 'ziro-phone-fx',
  templateUrl: './phone-fx.component.html',
  styleUrls: ['./phone-fx.component.scss'],
  standalone: false,
})
export class PhoneFxComponent implements OnChanges {
  readonly disabled = input<boolean>();
  readonly phoneName = input<string>();
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() unifiedFxUrl: string;

  ngOnChanges(): void {
    if (this.unifiedFxUrl && !this.unifiedFxUrl.startsWith('http')) {
      this.unifiedFxUrl = `http://${this.unifiedFxUrl}`;
    }
  }

  openPhoneFx(): void {
    const url = `${this.unifiedFxUrl}/#/phonefx/${this.phoneName()}`;
    const opts = 'height=745,width=493,menubar=no,resizable=no,scrollbars=no,toolbar=no';
    window.open(url, '', opts);
  }
}
